var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTurnOnOff = function SvgTurnOnOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8758 5.39848C17.5515 5.07421 17.0258 5.07421 16.7014 5.39848C16.3772 5.72275 16.3772 6.24841 16.7014 6.57268C18.2252 8.0964 19.0642 10.1223 19.0642 12.2772C19.0642 14.432 18.2252 16.4578 16.7014 17.9814C15.129 19.5539 13.0638 20.3401 10.998 20.3399C8.93227 20.3398 6.86607 19.5534 5.29341 17.9807C2.14866 14.836 2.14899 9.71888 5.29397 6.5739C5.61824 6.24963 5.61824 5.72386 5.29397 5.3997C4.96969 5.07542 4.44404 5.07542 4.11965 5.3997C0.327236 9.19211 0.326904 15.3628 4.1191 19.155C6.01581 21.0517 8.50681 22 10.9981 21.9999C13.4888 21.9998 15.9798 21.0517 17.8759 19.1557C19.7131 17.3186 20.7249 14.8757 20.7249 12.2773C20.725 9.6788 19.7131 7.23584 17.8758 5.39848Z",
    fill: "#707683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9971 10.7572C11.4558 10.7572 11.8274 10.3854 11.8274 9.92682V0.830335C11.8274 0.371769 11.4558 0 10.9971 0C10.5384 0 10.1667 0.371769 10.1667 0.830335V9.92682C10.1667 10.3855 10.5384 10.7572 10.9971 10.7572Z",
    fill: "#707683"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTurnOnOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/turn-on-off.e224d6b1.svg";
export { ForwardRef as ReactComponent };